module.exports = __webpack_public_path__ + "static/media/neca.582c3e72.png";